<template>
    <Table
        border
        disabled-hover
        :loading="loading"
        :columns="columns"
        :data="sorted"
        no-data-text="No tags yet."
    >
        <template slot-scope="{ row }" slot="tag">
            {{ row.tag_name }}
        </template>
        <template slot-scope="{ row }" slot="id">
            {{ row.id }}
        </template>
        <template slot-scope="{ row }" slot="label">
            <tag :tag="row.tag_name" :color="row.tag_color" class="ml-2"></tag>
        </template>
        <template slot-scope="{ row }" slot="actions">
            <Button
                v-if="$can('tags:update')"
                type="text"
                class="text-primary"
                @click="showEdit(row)"
                >Edit</Button
            >
        </template>
    </Table>
</template>

<script>
export default {
    props: {
        tags: Array,
        loading: Boolean,
    },
    components: {
        Tag: function () {
            return import("@/js/components/partials/tag");
        },
    },
    computed: {
        sorted() {
            return _.orderBy(
                this.tags,
                (tag) => {
                    return tag.tag_name.toLowerCase();
                },
                ["asc"]
            );
        },
    },
    data() {
        return {
            showSave: false,
            empty: false,
            columns: [
                {
                    title: "Tag",
                    key: "tag_name",
                    slot: "label",
                    align: "left",
                },
                {
                    title: "Api ID",
                    key: "id",
                    slot: "id",
                    align: "left",
                },
                {
                    title: "Action",
                    slot: "actions",
                    width: 95,
                    align: "center",
                },
            ],
        };
    },
    methods: {
        entity(tag) {
            switch (tag.entity_type_id) {
                case 1:
                    return "Account";
                    break;
                case 2:
                    return "Contact";
                    break;
                default:
                    return "Not Set";
                    break;
            }
        },
        onRemove(tag) {
            this.$emit("remove", tag);
        },
        async showEdit(tag) {
            this.$emit("edit", tag);
        },
    },
};
</script>
